import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetCustomerJourneys } from "src/app/store/customer-journey/customer-journey.action";

export function CustomerJourneyResolver() {
    return inject(Store).dispatch(new GetCustomerJourneys());
}